export const SET_MODAL = 'SET_MODAL';
export const CLEAR_MODAL = 'CLEAR_MODAL';
export const SET_LOADING = 'SET_LOADING';
